import "./Reports.css";
import React, { Fragment } from 'react'
// import dqi_params from '../../Pages/YH/DqDummy.js'
import { convertTimeStampToDate,getSuperheadeingColor,getSubeingColor } from './Reports.js';
function DQI_Summary({ dqi_params,thresholdColorsDqi }) {



  let totalLogs = 0;

  if (dqi_params?.data) {
    // Calculate the total number of logs
    dqi_params.data.businessUnit.forEach(provider => {
      provider.rigs.forEach(rig => {
        rig.wells.forEach(well => {
          totalLogs += well.logs.length;
        });
      });
    });

    const getDQIColor = (value) => {
      const matchingColor = thresholdColorsDqi?.find(colors => value <= parseInt(colors.maxThresholdValue));
    
      if (matchingColor) {
          return { backgroundColor: matchingColor.backgroundColor, color: matchingColor.color };
      }
  };
  
//   const filteredBusinessUnit = dqi_params.data.businessUnit.map(unit => ({
//     ...unit,
//     rigs: unit.rigs.map(rig => ({
//         ...rig,
//         wells: rig.wells.filter(well => well.logs.length > 0)
//     }))
// }));


const filteredBusinessUnit = dqi_params.data.businessUnit
    .map(unit => ({
        ...unit,
        rigs: unit.rigs
            .map(rig => ({
                ...rig,
                wells: rig.wells.filter(well => well.logs.length > 0)
            }))
            .filter(rig => rig.wells.length > 0)
    }))
    .filter(unit => unit.rigs.length > 0);


const totalProviderLogsforAll = filteredBusinessUnit.reduce((accProvider, provider) => {
  return accProvider + provider.rigs.reduce((accRig, rig) => {
    return accRig + rig.wells.reduce((accWell, well) => {
      return accWell + well.logs.length;
    }, 0);
  }, 0);
}, 0);


    return (
      <Fragment>

{
              (totalProviderLogsforAll !== 0 && filteredBusinessUnit.length > 0 )?
              <>

        <table className="tree-view">
          <thead>
            <tr style={getSuperheadeingColor()}><th colSpan={11}><b>Summary</b></th></tr>
            {/* <tr style={{background: "rgb(40, 102, 133)"}}> */}
            <tr style={getSubeingColor()}>
              <th className="forCenter"><b>Business Unit</b></th>
              <th className="forCenter"><b>Rig</b></th>
              <th className="forCenter"><b>Well</b></th>
              <th className="forCenter"><b>Log</b></th>
              <th className="forCenter"><b>Index Type</b></th>
              <th className="forCenter"><b>Start Index</b></th>
              <th className="forCenter"><b>End Index</b></th>
              {/* <th><b>Window Length</b></th> */}
              <th className="forCenter"><b>Data Provider</b></th>
              <th className="forCenter"><b>Log DQI (%)</b></th>
              <th className="forCenter"><b>Well DQI (%)</b></th>
            </tr>
          </thead>
          <tbody>

            {
              
              filteredBusinessUnit.map((provider) => {
                  let totalProviderLogs = provider.rigs.reduce((acc, rig) => {
                    return acc + rig.wells.reduce((accWell, well) => {
                      return accWell + well.logs.length;
                    }, 0);
                  }, 0);

                  return provider.rigs.map((rig, rigIndex) => {
                    let totalRigLogs = rig.wells.reduce((acc, well) => acc + well.logs.length, 0);
                    return rig.wells.map((well, wellIndex) => (
                        well.logs.length > 0 && well.logs.map((log, logIndex) => (
                        <tr key={`${provider.name}-${rig.name}-${well.name}-${log.name}`}>
                          {(rigIndex === 0  && wellIndex === 0 && logIndex === 0) && (
                          <td rowSpan={totalProviderLogs} className="forCenter" >{provider.name}</td>
                          )}
                          {(wellIndex === 0 && logIndex === 0 ) && (
                          <td className="forCenter" rowSpan={totalRigLogs} >{rig.name}</td>
                          )}
                          {(logIndex === 0) && 
                          <td className="forCenter" rowSpan={well.logs.length}>{well.name}</td>
                           } 
                          <td className="forRight">{log && log.name ?  log.name : "-"}</td>
                          <td className="forRight">{log.indexType || "-"}</td>
                          <td className="forRight">{log.indexType === "TIMESERIES" && log.startIndex !== "NOT CALCULATING" ? convertTimeStampToDate(log.startIndex) : log.startIndex || "-"}</td>
                          <td className="forRight">{log.indexType === "TIMESERIES" && log.endIndex !== "NOT CALCULATING" ? convertTimeStampToDate(log.endIndex) : log.endIndex || "-"}</td>
                          {/* <td>{log.windowLength || "-"}</td> */}
                          <td className="forCenter">{log.dataProvider || "-"}</td>
                          <td className="forCenter" style={getDQIColor(log.logDQIPercentage)}>{log.logDQIPercentage || "-"}</td>
                          {(logIndex === 0 ) && 
                          <td className="forCenter" rowSpan={well.logs.length} style={getDQIColor(well.wellDQIPercentage)}>{well.wellDQIPercentage || "-"}</td>
                          } 
                        </tr>
                      ))
                    ))
                  })
                })
            }
          </tbody>
        </table></>
        : <p style={{ textAlign: "center", fontWeight:"700" }}>Summary Data not Found</p>}
      </Fragment>
    );
  }
}
export default DQI_Summary